import React, { useEffect, useState } from "react";
import moment from "moment";
import SvgIcon from "../../../../../parts/SvgIcon";
const MonthSelector = ({ date, setDate }) => {
  const handleMonthChange = (month) => {
    const newDate = date.clone().month(month);
    setDate(newDate);
  };
  const handleAddYear = () => {
    setDate(date.clone().add(1, "year"));
  };

  const handleSubtractYear = () => {
    setDate(date.clone().subtract(1, "year"));
  };

  const currentYear = date.year();
  return (
    <div role="month-list-selector">
      <header>
        <h4>
          <b>{date.format("YYYY")}</b>
        </h4>
        <div>
          <button
            data-button-type="text-white"
            data-icon-only
            onClick={handleSubtractYear}
          >
            <SvgIcon src="/img/new-icons/arrow-left.svg" />
          </button>
          <button
            data-button-type="text-white"
            data-icon-only
            onClick={handleAddYear}
          >
            <SvgIcon src="/img/new-icons/arrow-right.svg" />
          </button>
        </div>
      </header>
      <ul>
        {moment.months().map((monthName, index) => {
          const month = moment().year(currentYear).month(index);
          const diff = month.diff(moment().startOf("month"), "months");
          const isFutureMonth = diff > 0;
          return (
            <li>
              <button
                // className={date.month() === index ? "month-active" : null}
                key={index}
                onClick={() => handleMonthChange(index)}
                disabled={isFutureMonth}
                data-button-type={
                  date.month() === index ? "primary" : "text-white"
                }
              >
                {monthName}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MonthSelector;
